export default "__VITE_ASSET__Bp7m91Ve__"